'use strict';
module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/is-alphanumeric/index.js
// module id = 1086
// module chunks = 0